import React from 'react';
import styled from 'styled-components';

const StyledChartPreview = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 270px;
  padding: 24px 12px;
  width: 100%;
  overflow: hidden;

  @media only screen and (max-width: 1199px) {
    flex-shrink: 0;
    height: 400px;
  }
`;

export const PanelChartPreview: React.FC<{children?: React.ReactNode}> = ({
  children,
}) => {
  return (
    <StyledChartPreview
      className="chart-preview"
      data-test="panel-chart-preview">
      {children}
    </StyledChartPreview>
  );
};
